export default __webpack_public_path__ + "static/media/icon-circle-line.da910ec3.svg";